/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import * as Users from '../../api/Users'
import * as Roles from '../../api/Roles'
import * as Fleets from '../../api/Fleets'
import * as Faults from '../../api/Faults'

export const REQUEST_USER = 'REQUEST_USER'
export const RECEIVE_USER = 'RECEIVE_USER'
export const CLEAR_LOADING = 'CLEAR_LOADING'
export const CLEAR_STATE = 'CLEAR_STATE'
export const SET_USER_ATTRIBUTE = 'SET_USER_ATTRIBUTE'
export const REQUEST_ROLES = 'REQUEST_ROLES'
export const RECEIVE_ROLES = 'RECEIVE_ROLES'
export const REQUEST_SUBMIT_USER = 'REQUEST_SUBMIT_USER';
export const RECEIVE_SUBMIT_USER = 'RECEIVE_SUBMIT_USER';
export const SET_ROLE = 'SET_ROLE'
export const SET_FLEET = 'SET_FLEET'
export const REQUEST_FLEETS_HIERARCHY = 'REQUEST_FLEETS_HIERARCHY'
export const RECEIVE_FLEETS_HIERARCHY = 'RECEIVE_FLEETS_HIERARCHY'
export const REQUEST_FAULTS = 'REQUEST_FAULTS'
export const RECEIVE_FAULTS = 'RECEIVE_FAULTS'
export const RECEIVE_ERROR = 'RECEIVE_ERROR'

export const fetchUser = (id) => dispatch => {
    dispatch(requestUser());
    return Users.fetchUser(id).then(
        function (response) {
            dispatch(receiveUser(response));
        }
    ).catch((err) => {
        dispatch(receiveErrorType(err));
    });
}

export const fetchRoles = (search, sort, sortOrder) => dispatch => {
    dispatch(requestRoles());
    return Roles.fetchRoles(search, sort, sortOrder).then(
        function (response) {
            dispatch(receiveRoles(response));
        }
    );
}

export const updateUser = (user) => dispatch => {
    dispatch(requestSubmitUser());
    return Users.updateUser(user).catch((err) => {
        dispatch(clearLoading());
        throw err;
    })
}

export const createUser = (user) => dispatch => {
    dispatch(requestSubmitUser());
    return Users.createUser(user).catch((err) => {
        dispatch(clearLoading());
        throw err;
    })
}

export const fetchFleetsHierarchy = () => dispatch => {
    dispatch(requestFleetsHierarchy());
    return Fleets.fetchHierarchy(false, false).then(
        function (response) {
            dispatch(receiveFleetsHierarchy(response));
        }
    );
}

export const deactivateUser = (userId) => dispatch => {
    dispatch(requestSubmitUser());
    return Users.deactivateUser(userId).catch((err) => {
        dispatch(clearLoading());
        throw err;
    });
}

export const reactivateUser = (userId) => dispatch => {
    dispatch(requestSubmitUser());
    return Users.reactivateUser(userId).catch(() => {
        dispatch(clearLoading());
    });
}

export const requestFaults = (states, search, sort, ids, assignee) => dispatch => {
    dispatch(requestFaultsType());
    return Faults.fetchFaultsWithoutPagination(states, search, sort, ids, assignee).then(
        function (pageableResponse) {
            dispatch(receiveFaultsType(pageableResponse.results));
        }
    );
}

export const requestFaultsType = () => {
    return {
        type: REQUEST_FAULTS,
    }
}

export const receiveFaultsType = (faults) => {
    return {
        type: RECEIVE_FAULTS,
        faults: faults,
    }
}

export const requestUser = () => {
    return {
        type: REQUEST_USER,
    }
}

export const receiveUser = (user) => {
    return {
        type: RECEIVE_USER,
        user: user,
    }
}

export const requestRoles = () => {
    return {
        type: REQUEST_ROLES,
    }
}

export const receiveRoles = (roles) => {
    return {
        type: RECEIVE_ROLES,
        roles: roles,
    }
}

const requestSubmitUser = () => {
    return {
        type: REQUEST_SUBMIT_USER,
    }
}

const receiveSubmitUser = (user) => {
    return {
        type: RECEIVE_SUBMIT_USER,
        user: user,
        loading: false,
    }
}

export const requestFleetsHierarchy = () => {
    return {
        type: REQUEST_FLEETS_HIERARCHY,
    }
}

export const receiveFleetsHierarchy = (fleets) => {
    return {
        type: RECEIVE_FLEETS_HIERARCHY,
        fleets: fleets,
    }
}

export const clearLoading = () => {
    return {
        type: CLEAR_LOADING,
    }
}

export const clearState = () => {
    return {
        type: CLEAR_STATE,
    }
}

export const setUserAttribute = (key, value) => {
    return {
        type: SET_USER_ATTRIBUTE,
        key: key,
        value: value,
    }
}

export const setRole = (index, role) => {
    return {
        type: SET_ROLE,
        index: index,
        role: role,
    }
}

export const setFleet = (fleets, role) => {
    return {
        type: SET_FLEET,
        fleets: fleets,
        role: role,
    }
}

export const receiveErrorType = (err) => {
    return {
        type: RECEIVE_ERROR,
        error: err,
    }
}
